<script setup lang="ts">
import { defineProps } from "vue";
import { RuneOfTheDayResponse } from "@/types/calculators";
import { useI18n } from "vue-i18n";

defineProps<{
  prediction: RuneOfTheDayResponse;
}>();

const { t } = useI18n();

function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
</script>

<template>
  <div class="w-full text-left mb-10 text-brown">
    <img
      :src="`${prediction.image}`"
      alt="DayRune"
      class="mx-auto mb-2 w-[109px] h-40 md:w-[146px] md:h-[213px]"
    />
    <h2
      class="text-2xl font-medium md:font-semibold leading-[32px] mb-10 text-center"
    >
      {{
        t("calculators.day-rune.results.day-rune", {
          name: prediction.name,
          code: capitalize(prediction.code),
        })
      }}
    </h2>

    <p class="mb-5 text font-bold">
      {{ t("calculators.day-rune.results.meaning") }}
    </p>
    <p class="mb-5 text">{{ prediction.meaning }}</p>

    <p class="mb-5 text font-bold">
      {{ t("calculators.day-rune.results.today-meaning") }}
    </p>
    <ul class="mb-5 list-disc pl-5 space-y-1 text">
      <li v-for="(val, key) in prediction.today" :key="key">
        {{ val }}
      </li>
    </ul>

    <p class="text">
      <span class="font-bold">
        {{
          t("calculators.day-rune.results.day-tip", { name: prediction.name })
        }}
      </span>
      {{ prediction.advice }}
    </p>
  </div>
</template>

<style>
.text {
  @apply text-base text-brown leading-[20px];
}
</style>
